import React, { useState } from "react";
// import DatePicker from 'react-datepicker';
import { Link } from "react-router-dom";
import Sidebar from "../sidebar/SideBar";
import Header from "../../header/Header";
import { Typography } from "antd";
import BackgroundImage from "../../accordian/BackgroundImage";
import ProfileImage from "../../accordian/ProfileImage";
import PersonalInfo from "../../accordian/PersonalInfo";
import SocialMedia from "../../accordian/SocialMedia";
import ContactDetails from "../../accordian/ContactDetails";
import Gallery from "../../accordian/Gallery";
import WebSite from "../../accordian/WebSite";
import Theme from "../../themes/Theme";
import './Interface.css'
import ReviewAccordian from "../../accordian/Review";
import Interview from "../../accordian/Interview";
import PreviousWork from "../../accordian/PreviousWork";

const { Title } = Typography;

const Interface = ({edit}) => {
  const secondaryColor="#278D27"
  const textColor = '#FFFFFF'
  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <Sidebar secondaryColor={secondaryColor} textColor={textColor} />

        {/* Page Wrapper */}

        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Add Interface</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/department">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Interface</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <h1>InterFace Area</h1>

                    <div className="previewWrapBlock">
                      <div className="md:w-7/12 flex justify-center overflow-auto scrollbar-hide">
                        <div className="w-100">
                          

                          <div className="w-12/12  mt-10 ">
                          

                            <div className="my-5 flex flex-col gap-2 ">
                      
                              <BackgroundImage />
                              <ProfileImage edit={edit} />
                              {/* <CompanyLogo edit={edit} /> */}
                             {/* <BackgroundImage /> */}
                              <PersonalInfo edit={edit} />
                              <SocialMedia />
                              <ContactDetails />
                              <WebSite edit={edit} />
                              <PreviousWork edit={edit} />
                              <ReviewAccordian edit={edit} />
                              <Interview edit={edit} />
                              {/* <FileUploader edit={edit} /> */}
                              <Gallery edit={edit} />
                              <div className="mt-5">


                                <div className="display: flex space-x-3.5 py-2 mt-2">
                                  {edit ? (
                                    <>
                                      <button
                                        className="text-white bg-slate-700 hover:bg-slate-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 "
                                        // onClick={handleCancel}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="text-white bg-emerald-500 hover:bg-emerald-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 "
                                        // onClick={handleClearChanges}
                                      >
                                        Clear all
                                      </button>

                                      <button
                                        // onClick={handleSubmit}
                                        type="button"
                                        className="text-white bg-orange-600 hover:bg-orange-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 "
                                      >
                                        Update and Publish
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 "
                                        // onClick={handleClear}
                                      >
                                        Clear Data
                                      </button>
                                      {/* {cardCount >= limit ? (
                                        <Tooltip placement="top" title="Card Limit Over">
                                          <Button
                                            type="primary"
                                            disabled
                                            style={{ height: "40px" }}
                                          >
                                            Save and Publish
                                          </Button>
                                        </Tooltip>
                                      ) : ( */}
                                        <button
                                          // onClick={handleSubmit}
                                          type="button"
                                          className="text-white bg-orange-600 hover:bg-orange-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 "
                                        >
                                          Save and Publish
                                        </button>
                                      {/* )} */}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="md:w-5/12 flex items-center lg:justify-end">
                        <div className="flex ">
                          <div className="mobilePreview">
                            <div className="mobilePreviewB">
                              <div className="themepreviewWrap">
                                <Theme/>
                                {/* {userDatas.theme === "standard1" ? (
                                  <StandardTheme edit={edit} />
                                ) : userDatas.theme === "minimal1" ? (
                                  <MinimalTheme edit={edit} />
                                ) : userDatas.theme === "classic1" ? (
                                  <ClassicTheme edit={edit} />
                                ) : userDatas.theme === "classic2" ? (
                                  <ClassicTheme2 edit={edit} />
                                ) : userDatas.theme === "modern1" ? (
                                  <ModernTheme edit={edit} />
                                ) : userDatas.theme === "standardDark1" ? (
                                  <StandardDarkTheme edit={edit} />
                                ) : userDatas.theme === "epic" ? (
                                  <EpicTheme edit={edit} />
                                ) : userDatas.theme === "antique" ? (
                                  <AntiqueTheme edit={edit} />
                                ) : userDatas.theme === "ideal" ? (
                                  <IdealTheme edit={edit} />
                                ) : userDatas.theme === "digital1" ? (
                                  <DigitalTheme1 edit={edit} />
                                ) : userDatas.theme === "ultra" ? (
                                  <UltraTheme edit={edit} />
                                ) : userDatas.theme === "vex" ? (
                                  <VexTheme edit={edit} />
                                ) : userDatas.theme === "iconic" ? (
                                  <IconicTheme edit={edit} />
                                ) : userDatas.theme === "tech" ? (
                                  <TechTheme edit={edit} />
                                ) : (
                                  ""
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {loader} */}
                      {/* <ToastContainer /> */}
                      <button className="fixed bottom-5 right-3">
                        <a href="https://wa.me/+971505363704?text=Hi%2C" target="blank">
                          {/* <img src={Whatsapp} /> */}
                        </a>
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default Interface;
